const experiences = {
    firestorePath: '/experiences',
    firestoreRefType: 'collection',
    moduleName: 'experiences',
    statePropName: 'experiences',
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: '%convertTimestamp%', // default
            updated_at: '%convertTimestamp%', // default
        },
    },
    state: {
        experiences: [],
    },
    getters: {
        getAllExperiences: (state) => {
            return _.toArray(state.experiences);
        },
        getExperiences: (state) => {
            let experiences = _.toArray(state.experiences);
            return experiences.filter(experiences => experiences.standard === true)
        },
        getOtherExperiences: (state) => {
            let experiences = _.toArray(state.experiences);
            return experiences.filter(experiences => experiences.standard === false)
        },
    },
    mutations: {

    },
    actions: {},
}

export default experiences